import styled from 'styled-components';

/* Siatka kafelków integracji — jeden kafelek = jeden zewnętrzny system.
   Kolejne integracje (np. inne PMS-y) dokładamy tu bez zmian w layoucie. */
export const TileGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 12px;
`;

export const Tile = styled.button`
  display: flex;
  align-items: flex-start;
  gap: 14px;
  width: 100%;
  padding: 16px 18px;
  text-align: left;
  font-family: inherit;
  cursor: pointer;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.border.primary};
  background: ${({ theme }) => (theme.mode === 'dark' ? theme.colors.background.card : '#ffffff')};
  transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.1s ease;

  &:hover {
    border-color: ${({ theme }) => (theme.mode === 'dark' ? '#4b5563' : '#9ca3af')};
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  }

  &:active {
    transform: scale(0.995);
  }

  &:focus-visible {
    outline: 2px solid #1a4d4d;
    outline-offset: 2px;
  }
`;

export const TileIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border-radius: 4px;
  overflow: hidden;

  svg,
  img {
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 4px;
  }
`;

export const TileBody = styled.span`
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
  flex: 1;
`;

export const TileTitle = styled.span`
  font-size: 14px;
  font-weight: 500;
  line-height: 1.3;
  color: ${({ theme }) => theme.colors.text.primary};
`;

/* Opis przycięty do dwóch linii — kafelki stoją w siatce i różna liczba linii
   rozjeżdżała ich wysokość. Pełna treść zostaje w tooltipie (`title`). */
export const TileDesc = styled.span`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-size: 12.5px;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

/* Wygląda jak link, ale jest spanem: cały kafelek to <button>, a zagnieżdżony
   element interaktywny byłby niepoprawnym HTML-em i pułapką dla czytników ekranu. */
export const TileAction = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: 6px;
  font-size: 12px;
  font-weight: 500;
  color: #1a4d4d;

  ${Tile}:hover & {
    text-decoration: underline;
  }
`;

/* Status w osobnej linii NAD nazwą — kafelek czyta się wtedy z góry na dół:
   „czy działa", potem „co to jest". `align-self` trzyma go przy lewej krawędzi
   i nie pozwala kropce rozjechać się na całą szerokość kolumny. */
export const TileStatus = styled.span<{ $active: boolean }>`
  display: inline-flex;
  align-self: flex-start;
  align-items: center;
  gap: 6px;
  margin-bottom: 1px;
  font-size: 11.5px;
  font-weight: 400;
  letter-spacing: 0.01em;
  color: ${({ $active, theme }) => ($active ? '#059669' : theme.colors.text.secondary)};

  &::before {
    content: '';
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: ${({ $active }) => ($active ? '#10b981' : '#9ca3af')};
  }
`;
